import React from "react";
import styled from "styled-components";
import { rem } from "polished";
import colors from "../../../utils/colors";

const forWidths = (widths, el = "td") => {
  const w = widths.map((w, index) => {
    return `${el}:nth-child(${index + 1}) {
      width: ${w};
    }`;
  });
  return w;
};

const StyledTable = styled.table`
  margin: 0 0 ${rem("16px")} 0;
  width: 100%;
  text-align: left;
  font-size: ${rem("18px")};
  table-layout: fixed;

  thead tr:first-child {
    ${props => props.widths && forWidths(props.widths, "th")};
  }

  tbody tr:first-child {
    ${props => props.widths && forWidths(props.widths)};
  }

  th {
    text-transform: uppercase;
    padding: 0.125rem 0.75rem 0.875rem 0;
    color: ${colors.GRAY};
  }

  td {
    padding: ${rem("6px")} ${rem("12px")} ${rem("6px")} 0;

    &.strong {
      font-family: FyranSans-SemiBold;
    }
  }

  th,
  td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  a {
    color: ${colors.BRAND_RED};
  }

  thead {
    font-size: ${rem("14px")};
  }

  tfoot {
    font-family: FyranSans-SemiBold;
    td {
      padding-top: 1rem;
    }
  }

  tfoot {
    th {
      padding: ${rem("16px")} ${rem("12px")} 0 0;
    }
  }
`;

const Table = props => {
  const { items, renderHeader, renderFooter, renderItem, ...rest } = props;

  return (
    <StyledTable {...rest}>
      {renderHeader ? <thead>{renderHeader()}</thead> : null}
      <tbody>{items.map(renderItem)}</tbody>
      {renderFooter ? <tfoot>{renderFooter()}</tfoot> : null}
    </StyledTable>
  );
};

export default Table;



// WEBPACK FOOTER //
// ./src/modules/common/components/Table.js